var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnityCalculate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calculate") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 0h-16c-2.209 0-4 1.791-4 4v0 24c0 2.209 1.791 4 4 4v0h16c2.209 0 4-1.791 4-4v0-24c0-2.209-1.791-4-4-4v0zM26 28c-0.001 1.104-0.896 1.999-2 2h-16c-1.104-0.001-1.999-0.896-2-2v-24c0.001-1.104 0.896-1.999 2-2h16c1.104 0.001 1.999 0.896 2 2v0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 4h14c0.552 0 1 0.448 1 1v4c0 0.552-0.448 1-1 1h-14c-0.552 0-1-0.448-1-1v-4c0-0.552 0.448-1 1-1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24 14c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16 24h-6c-1.105 0-2 0.895-2 2s0.895 2 2 2v0h6c1.105 0 2-0.895 2-2s-0.895-2-2-2v0z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24 26c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M24 20c0 1.105-0.895 2-2 2s-2-0.895-2-2c0-1.105 0.895-2 2-2s2 0.895 2 2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityCalculate);
export default __webpack_public_path__ + "static/media/unity_calculate.ae55392c752ca763e380414689349f18.svg";
export { ForwardRef as ReactComponent };